import { getCurrentAsaasIdentityKey } from './identity';
import { getAsaasHandoff } from './handoff';
import { buildAsaasPaymentResultUrl } from './returnHandoff';
import type { AsaasOrderAttempt } from './types';

const idempotencyByBucket = new Map<string, { signature: string; idempotent: string }>();

function idempotencyBucket(scope: string): string {
  return `${getCurrentAsaasIdentityKey() ?? 'anonymous'}:${scope}`;
}

export function asaasIdempotencyKey(scope: string, signature: string): string {
  const bucket = idempotencyBucket(scope);
  const current = idempotencyByBucket.get(bucket);
  if (current?.signature === signature) return current.idempotent;
  const idempotent = crypto.randomUUID();
  idempotencyByBucket.set(bucket, { signature, idempotent });
  return idempotent;
}

export function releaseAsaasIdempotencyKey(scope: string): void {
  idempotencyByBucket.delete(idempotencyBucket(scope));
}

export function prepareAsaasOrderAttempt(scope: string, signature: string): AsaasOrderAttempt {
  const returnId = crypto.randomUUID();
  return {
    returnId,
    idempotent: asaasIdempotencyKey(scope, signature),
    payResultUrl: buildAsaasPaymentResultUrl(returnId, getAsaasHandoff()),
    idempotencyScope: scope,
  };
}

export function clearAsaasIdempotencyKeys(): void {
  idempotencyByBucket.clear();
}
